import {componentHandler} from './materialDesignLite';
import {Directive, ElementRef, OnInit, OnDestroy} from '@angular/core';

@Directive({
    selector: '[mdl]'
})
export class Mdl implements OnDestroy, OnInit {
    constructor(private element: ElementRef) {
    }

    public ngOnInit() {
        const nativeElement = this.element.nativeElement as Element;
        console.debug(`mdl initialized on ${nativeElement.nodeName}`);
        componentHandler.upgradeElements(nativeElement);
    }

    public ngOnDestroy() {
        componentHandler.downgradeElements(this.element.nativeElement);
    }
}